import { injectionKey } from '@shared/injection'
import { provideSSRWidth as provideVueUseWidth, useBreakpoints } from '@vueuse/core'

const breakpointsInjectionKey = injectionKey('breakpoints')

export function setupScreen () {
  const breakpoints = useBreakpoints({
    phone: 440,
    desktop: 1024,
  })

  return reactive({
    isPhone: breakpoints.smaller('phone'),
    isMobile: breakpoints.smaller('desktop'),
    isDesktop: breakpoints.desktop,
  })
}

// NOTE: Allows to reuse the same breakpoints across the app.
export function useScreen () {
  let screen = inject<ReturnType<typeof setupScreen> | undefined>(breakpointsInjectionKey, undefined)

  if (!screen) {
    provideSSRWidth()
    screen = setupScreen()
    provide(breakpointsInjectionKey, screen)
  }

  return screen
}

export function provideSSRWidth (app?: Parameters<typeof provideVueUseWidth>[1]) {
  return provideVueUseWidth(440, app)
}

export function prefersReducedMotion () {
  if (import.meta.env.SSR) return false

  const mediaQuery = matchMedia('(prefers-reduced-motion: reduce)')
  return mediaQuery.matches
}
